module.exports = __webpack_public_path__ + "img/rings-wedding.9e985036.svg";